/**
 * @generated SignedSource<<b2bdfb5475a8a0f5a1650f0921f4f706>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "languageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seq"
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "facilityLocationLanguageId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "languageId",
        "variableName": "languageId"
      },
      {
        "kind": "Variable",
        "name": "seq",
        "variableName": "seq"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditFacilityLocationLanguageModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FacilityLocationLanguageModifyPayload",
            "kind": "LinkedField",
            "name": "modifyLanguage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationLanguage",
                "kind": "LinkedField",
                "name": "facilityLocationLanguage",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationLanguage",
                        "kind": "LinkedField",
                        "name": "languages",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FacilityLocationLanguages_Languages"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditFacilityLocationLanguageModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FacilityLocationLanguageModifyPayload",
            "kind": "LinkedField",
            "name": "modifyLanguage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationLanguage",
                "kind": "LinkedField",
                "name": "facilityLocationLanguage",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationLanguage",
                        "kind": "LinkedField",
                        "name": "languages",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Language",
                            "kind": "LinkedField",
                            "name": "language",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isoCode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayOrder",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "seq",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d5cb671a4dcfb9c2f34861dbb040aac6",
    "id": null,
    "metadata": {},
    "name": "EditFacilityLocationLanguageModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditFacilityLocationLanguageModalMutation(\n  $id: ID!\n  $languageId: ID!\n  $seq: Int!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  facilityLocation {\n    modifyLanguage(input: {facilityLocationLanguageId: $id, languageId: $languageId, seq: $seq, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      facilityLocationLanguage {\n        id\n        facilityLocation {\n          languages {\n            ...FacilityLocationLanguages_Languages\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FacilityLocationLanguages_Languages on FacilityLocationLanguage {\n  id\n  language {\n    id\n    name\n    isoCode\n    displayOrder\n  }\n  seq\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "11d404f4713d2bf9f33cc27b35f2187b";

export default node;
